import React, { useRef, useState } from 'react';
import './anonymization.scss';
import { MotifTable } from '@ey-xd/motif-react';
import { TableHeader } from './TableHeader';
import { useNavigate } from "react-router-dom";
import { MotifProgressLoader, MotifProgressBar } from '@ey-xd/motif-react';
import { Stepper } from '../stepper/stepper';
import { apiQueryWithToken } from '../../common/services/apiBaseUrlConfig';
import logger from "../../common/utils/logger";

export const Anonymization = () => {
  const [searchValue, setSearchValue] = useState('');
  const [anonymizeData, setAnonymizeData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false);


  const filteredData = Object.values(anonymizeData?.filter((item) => { return item.fileName.toLowerCase().includes(searchValue.toLowerCase()) })
  );

  React.useEffect(() => {
    getData();
    const intervalId = setInterval(getData, 20000);
    return () => clearInterval(intervalId);
}, []);

  const gridRef = useRef();
  const navigation = useNavigate();

  const onFilterTextBoxChanged = (value) => {
    logger.info('QQ filter', value, gridRef);
    setSearchValue(value);
  };

  const getData = React.useCallback(() => {
    setIsLoading(true);
    apiQueryWithToken.get(`api/Anonymization/GetStatus`).then((data) => {
      setAnonymizeData(data.data);
      setIsLoading(false);
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        navigation('/');
        } else{
          logger.error('An error occurred:', error);
          setIsLoading(false);
        }
    })
  })

  const columnDefs = [
    {
      field: 'controlid',
      headerName: 'ID',
      width: 80,
      resizable:true
    },
    {
      field: 'fileName',
      filter: true,
      headerName: 'File Name',
      width: 120,
      resizable:true
    },
    {
      field: 'fileType',
      filter: true,
      headerName: 'File Type',
      width: 120,
      resizable:true
    },
    {
      field: 'area',
      filter: true,
      headerName: 'Area',
      width:120      
    },
    {
      field: 'region',
      filter: true,
      headerName: 'Region',
      width:120,
      resizable:true
    },
    {
      field: 'country',
      filter: true,
      headerName: 'Country',
      width: 130,
      resizable:true
    },
    {
      field: 'sector',
      filter: true,
      headerName: 'Sector',
      width: 120,
      resizable:true
    },
    {
      field: 'subSector',
      filter: true,
      headerName: 'Subsector',
      width: 140,
      resizable:true
    },
    {
      field: "subSubSector",
      filter: true,
      headerName: "Sub-Sub Sector",
      width: 170,
      resizable:true
    },
    {
      field: 'function',
      filter: true,
      headerName: 'Function',
      width: 130,
      resizable:true
    },
    {
      field: 'marketSize',
      filter: true,
      headerName: 'Revenue Range',
      width: 170,
      resizable:true
    },
    {
      cellRenderer: dotCellRenderer,
      field: 'anonymizationStatus',
      headerName: 'Anonymization Status',
      filter: true,
      width: 120,
      resizable:true
    },
    {
      cellRenderer:progressCellRenderer,
      field: 'score',
      filter: true,
      headerName: 'Score',
      width: 120,
      resizable:true
    },
    {
      cellRenderer: dotCellRenderer,
      field: 'qcStatus',
      headerName: 'Status',
      filter: true,
      width: 120,
      resizable:true
    },
    {
      field: 'uploaded_By',
      filter: true,
      headerName: 'Uploaded By',
      width: 300,
      resizable:true
    }
  ];

  return (
    <div className='anonymization-container'>
      <div className='page-title-wrap'>
        <h3>Anonymization</h3>
      </div>
      <Stepper />
      {
        filteredData &&  <div className='grid-wrapper'>
        <TableHeader
          onFilterTextBoxChanged={onFilterTextBoxChanged}
          searchValue={searchValue}
          navigation={navigation}
        />
        <div className='grid-container'>
          {
            isLoading ? <MotifProgressLoader
              show
              variant="default"
            /> : <div className={'ag-theme-quartz grid-container-inner'}>
              <MotifTable
                columnDefs={columnDefs}
                description='Descriptive text that describes your page or content.'
                name='Default'
                pagination
                paginationPageSize={10}
                paginationPageSizeSelector={[3, 4, 5]}
                rowData={filteredData}
                zebra={false}
              />
            </div>
          }
        </div>
      </div>
      }
    </div>
  );
};

const dotCellRenderer = ({ value }) => {

  const showStatus = value?.replace(/\s/g, '').toLowerCase();
  return (
    <div
      className={`motif-dot ${showStatus === 'inprogress' && 'motif-dot-left'} ${(showStatus === 'success' || showStatus === 'completed') && 'motif-dot-success'
        } ${showStatus === 'failed' && 'motif-dot-error'} ${showStatus === 'inprogress' && 'motif-dot-warning'
        }`}
    >
      <span className='motif-dot-text'>{value}</span>
    </div>
  );
};


const progressCellRenderer = ({ value }) => {
  const index = value.indexOf('%');
  const numericValue =  Number(value.substring(0, index));
  return (
    <MotifProgressBar
    labelPosition="default"
    value={numericValue}
    processStateLabel=""
    resultStateLabel=""
    variant="default"
    className={numericValue > 70  ? 'motif-success' : numericValue > 30 ?  'motif-score' :  'motif-failed'}
  />
  );
};
